<template>
    <div style="width:100%">
        <gmap-map
            :zoom="12"
            :center="retrievePickupPosition(positions)"
            class="animation"
            :style="`{width:100%; height:${height};}`"
            ref="googlemapref"
            :options="options"
        >
            <gmap-marker :icon="pickup_icon" :visible="retrievePickupPosition(positions).lat !== '0'" :animation="1" :position="retrievePickupPosition(positions)" :draggable="false" :label="renderLabel('Location 1')"></gmap-marker>
            <gmap-marker :icon="dropoff_icon" :visible="renderPosition(dropoff).lat !== '0'" :animation="1" :position="dropoff"
              :draggable="false" v-for="(dropoff, index) in retrieveDropoffPosition(positions)" :key="`dropoff_${index}`" :label="renderLabel('Location ' + (index + 2))">
            </gmap-marker>
        </gmap-map>
    </div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'
import {loaded} from 'vue2-google-maps'

export default {
    name: 'map-markers-component',
    props:['positions', 'custom_height', 'show_travel_line'],
    data () {
        var self = this
        return {
            directionsService:null,
            directionsDisplay:null,
            directionsDisplay2:null,
            center: { lat: 1.383327, lng: 103.844422 },
            height:self.custom_height,
            pickup_icon: {
                url: "/../images/map-markers/pickup.png",
                scaledSize: {width: 35, height: 35},
                labelOrigin: {x: 16, y: -10}
            },
            dropoff_icon:{
                url: "/../images/map-markers/dropoff.png",
                scaledSize: {width: 35, height: 35},
                labelOrigin: {x: 16, y: -10}
            },
            options: {
                styles:[
                  {
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e6e6e6"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.icon",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#616161"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                      {
                        "color": "#e6e6e6"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#e6e6e6"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape.natural",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#d6ebcc"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#eeeeee"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "stylers": [
                      {
                        "color": "#dedede"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#ffffff"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "stylers": [
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#dadada"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#616161"
                      }
                    ]
                  },
                  {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  },
                  {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                    ]
                  },
                  {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#eeeeee"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#c9c9c9"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#cad2d3"
                      }
                    ]
                  }
                ]
            }
        }
    },
    mounted(){
        this.$refs.googlemapref.$mapPromise.then((map) => {
            // var is_pickup_bound = false;
            var is_bound = false;

            var bounds = new google.maps.LatLngBounds();

            // var _pickup = this.renderPosition(this.pickup_position)
            // if(_pickup.lat !== 0){
            //     is_pickup_bound = true
            //     bounds.extend(_pickup);
            // }

            this.positions.map((dropoff, index) => {
              if(dropoff.lat !== 0){
                is_bound = true
                bounds.extend(dropoff);
              }
            })

            if(!is_bound){
                bounds.extend(this.center)
                bounds.extend({
                    lat: 1.320513096245,
                    lng: 103.916088026231
                })
            }

            this.$refs.googlemapref.fitBounds(bounds);

            if(this.show_travel_line && is_bound){
                this.renderRoutesOnMap(this.positions)
            }
        })
    },
    computed: {
        google: gmapApi
    },
    methods: {
        googleInit() {
            if (!this.directionsService) {
                this.directionsService = new google.maps.DirectionsService();
            }
            if (!this.directionsDisplay) {

                this.directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers: true});
                this.directionsDisplay.setMap(this.$refs.googlemapref.$mapObject);
            }
        },
        renderRoutesOnMap(positions){
            // Initialise some variables
            var limit;
            var requestObject = {}

            let locations = positions

            generateRequests();

            this.googleInit();
            let directionsDisplay = this.directionsDisplay;
            let directionsService = this.directionsService;

            if(requestObject.request.destination && requestObject.request.origin){
                directionsService.route(requestObject.request, (response, status) => {
                    if (status === 'OK') {
                        let routes = response.routes[0].legs

                        this.$emit('onRenderRouteMap', routes)

                        directionsDisplay.setDirections(response)
                    } else {
                        console.log(status);
                        console.log(response);
                    }
                })
            }

            // Let's make an array of requests which will become individual polylines on the map.
            function generateRequests(){

                requestObject = {};
                var waypts = [];

                var start, finish

                var lastpoint

                limit = locations.length

                for (var waypoint = 0; waypoint < limit; waypoint++) {
                    locations[waypoint].lat = parseFloat(locations[waypoint].lat)
                    locations[waypoint].lng = parseFloat(locations[waypoint].lng)

                    if (locations[waypoint] === lastpoint){
                        continue;
                    }

                    lastpoint = locations[waypoint]

                    waypts.push({
                        location: locations[waypoint],
                        stopover: true
                    });

                }
                start = waypts.shift()

                if(start){
                    if('location' in start){
                        start = start.location
                    }
                }
                finish = waypts.pop()

                if(finish === undefined){
                    finish = start;
                } else {
                    finish = finish.location;
                }

                var request = {
                    origin: start,
                    destination: finish,
                    waypoints: waypts,
                    travelMode: google.maps.TravelMode.DRIVING
                };

                requestObject = {"route": 'Dropoff', "request": request};
            }
        },
        renderPosition(position){
            var val = {
                lat: parseFloat(position ? position.lat : 0),
                lng: parseFloat(position ? position.lng : 0),
            }

            return val
        },
        retrievePickupPosition(positions){
          return this.renderPosition(positions[0])
        },
        retrieveDropoffPosition(positions){
          var arr = []

          for(let i = 1; i < positions.length; i++){
            arr.push(this.renderPosition(positions[i]))
          }

          if(!arr.length){
            arr = [{lat:0, lng:0}]
          }

          return arr
        },
        renderLabel(text){
            return { fontWeight: 'bold', fontSize: '12px', text: text }
        }
    }
}
</script>
